<template>
  <div />
</template>
<script>
export default {
  name: 'Login',
  async created() {
    await this.$store.dispatch('authorization/checkIfUserSessionExists', { endpoint: '/authorization/checkIfUserSessionExist' });
    const isAuthenticated = this.$store.getters['authorization/isAuthenticated'];
    if (isAuthenticated) {
      this.$router.push({ path: '/' });
    } else {
      const gateway = '78a35bcb-3063-41e8-be99-c6f69fb1c0d7';
      this.$auth.loginToPlatform({ gateway, lang: 'pl' });
    }
  },
};
</script>
